import { Component, Input, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getEmptyField } from '@core/_utils/tools.utils';
import { EditorService } from '@service/editor.service';

@Component({
    selector: 'basketfilter',
    templateUrl: 'basketfilter.component.html',
    styleUrls: ['basketfilter.component.scss'],
})
export class BasketFilterComponent {
    @Input()
    @Output()
    public visible: boolean;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    @Output()
    public onSelectFilter: EventEmitter<any> = new EventEmitter();

    @Input()
    public data;
    @Input()
    public filterAuto = false;
    @Input() public editorService: EditorService;

    public error = false;
    public errorMessage = '';
    public loadingMessage = '';
    public listRequest: any;
    private emptyField: boolean = true;

    constructor(private translate: TranslateService) {
        this.loadingMessage = this.translate.instant('Load_Data');
    }

    ngOnChanges() {
        if (this.data && this.data.selectedRequestId) {
            this.selectRequest(this.data.selectedRequestId);
        }
    }

    public onClickRequest({ value }) {
        this.selectRequest(value);
    }

    public onClickFilter($event) {
        if ($event === true && this.data.selectedRequestId !== -1) {
            this.onSelectFilter.emit({
                variableListRequest: this.data.selectedRequest,
                filterAuto: this.filterAuto,
                emptyField: this.emptyField,
                filterActiv: true,
            });
        } else {
            this.onSelectFilter.emit({
                variableListRequest: [],
                filterAuto: false,
                emptyField: true,
                filterActiv: false,
            });
        }
    }

    public close() {
        this.onClose.emit();
    }

    private selectRequest(requestId) {
        let wRes: any;
        this.emptyField = true;
        if (requestId !== -1) {
            wRes = this.data.requestList.find(({ id }) => id === requestId);
            if (wRes !== undefined) {
                this.data.selectedRequest = wRes.webReqDetails;
                this.emptyField = getEmptyField(wRes.emptyfield);
                this.data.selectedRequestId = requestId;
            }
        }
    }
}
